import React from "react";

export default function ViewOnceReceivedNotice({ time, senderName }) {
    return (
        <div className="max-w-xs lg:max-w-lg rounded-xl bg-white border border-gray-200 px-3 py-3">
            {senderName ? (
                <p className="mb-2 text-xs font-semibold text-gray-700">{senderName}</p>
            ) : null}
            <div className="flex items-start gap-3">
                <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 border-dashed border-[#7C4DFF] text-xs font-semibold text-[#7C4DFF]">
                    1
                </div>
                <div className="min-w-0 flex-1">
                    <p className="text-sm italic leading-snug text-gray-600">
                        You received a view once message. For added privacy, you can only open it on your phone. 
                         <span className="inline-block text-sm font-medium text-[#7C4DFF]">
                         Learn more
                    </span>    </p>
                   
                </div>
            </div>
            {time ? (
                <span className="mt-2 block text-end text-xs text-gray-500">{time}</span>
            ) : null}
        </div>
    );
}
